// extracted by mini-css-extract-plugin
export var chevron = "_bz-4";
export var chevronExpanded = "_bz-5";
export var row = "_bz-0";
export var rowBody = "_bz-6";
export var rowDescription = "_bz-7";
export var rowHeader = "_bz-1";
export var rowTitle = "_bz-2";
export var rowTitleComplete = "_bz-3";